import { Storage } from 'aws-amplify';
import { validateAndResizeCreative } from './validateAndResizeCreative';

export const uploadFileToS3 = async ({ file, mediaType = 'STILL', validDimensions = null }) => {
  try {
    const { name, size, type } = file;

    if (size > 5 * 1024 * 1024) {
      throw new Error("File can't exceed 5MB");
    }

    // If validDimensions provided, validate and optionally auto-resize before upload
    let processedFile = file;
    let imageWidth = null;
    let imageHeight = null;

    if (validDimensions && validDimensions.length > 0) {
      const result = await validateAndResizeCreative(file, validDimensions);
      processedFile = result.file;
      imageWidth = result.width;
      imageHeight = result.height;
    }

    const fname = `${new Date().getTime()}-${name}`;
    const response = await Storage.put(fname, processedFile, {
      contentType: type,
    });

    const { key } = response;
    const url = await Storage.get(key, {
      // TODO: Create a global config for expiry time
      expires: 600000, // 10 minutes expiry time
    });

    return {
      key,
      url,
      name,
      size,
      fileType: key.split('.')[1].toUpperCase(),
      type: mediaType,
      ...(imageWidth != null ? { width: imageWidth, height: imageHeight } : {}),
    };
  } catch (error) {
    console.error('uploadFileToS3 failed:', error);
    throw error;
  }
};
